const EVENT_LIKE = 'event-like';

const likeEventTrigger = () => {
  document.querySelectorAll('.js-like-it .js-heart, .js-like-btn .js-heart')
      .forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('icon-heart')) {
        const event = new CustomEvent(EVENT_LIKE);
        document.dispatchEvent(event);
      }
    });
  });
};

export {EVENT_LIKE, likeEventTrigger};